import type { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-enterprise'
import type { CustomCellRendererProps } from 'ag-grid-react'
import type { ReactElement } from 'react'
import type { Menu } from '~/components/ActionMenu'
import type { INavigationGraph } from '~/types/navigation-graph'
import type { IUserPublic } from '~/types/user'

import ActionMenu from '~/components/ActionMenu'
import { NavigationGraphBadge } from '~/components/Badges'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { ASSET_STATUS_LABEL_MAPPING } from '~/const'
import { ASSET_STATUS } from '~/types/assets-management'
import { actionsColDef, applicationColDef, lastUpdateColDef, textColDef } from '~/utils/table'

const NavigationGraphStatusRenderer = ({ data }: CustomCellRendererProps<INavigationGraph>): ReactElement | null => {
  return data ? (
    <div className="badges-container">
      <NavigationGraphBadge size="medium" value={data.status} />
    </div>
  ) : null
}

const ActionsCellRenderer = ({ context, data }: ICellRendererParams): ReactElement => {
  const { uuid } = data as INavigationGraph
  const { handleCopyId } = context

  const menu: Menu = {
    actions: [
      {
        action: () => handleCopyId(uuid),
        label: 'Copy Navigation graph ID',
      },
    ],
  }

  return <ActionMenu menu={menu} placement="bottom" />
}

const columns: ColDef<INavigationGraph & { updated_by?: IUserPublic }>[] = [
  textColDef(TextCellRenderer, {
    field: 'title',
    filterParams: {
      buttons: ['clear'],
      filterOptions: ['equals', 'contains'],
      suppressAndOrCondition: true,
    },
    headerName: 'Name',
    suppressSizeToFit: true,
    width: 350,
  }),
  applicationColDef({
    field: 'application',
    minWidth: 350,
    sortable: false,
  }),
  {
    cellRenderer: NavigationGraphStatusRenderer,
    field: 'status',
    filter: 'agSetColumnFilter',
    filterParams: {
      valueFormatter: (params: ValueFormatterParams) => ASSET_STATUS_LABEL_MAPPING[params.value as ASSET_STATUS],
      values: Object.values(ASSET_STATUS),
    },
    headerName: 'Status',
    menuTabs: ['filterMenuTab'],
    minWidth: 150,
    suppressSizeToFit: true,
    width: 180,
  },
  lastUpdateColDef({
    field: 'updated_at',
  }),
  actionsColDef(ActionsCellRenderer, {
    field: 'actions',
  }),
]

export default columns
